export var AnnounceFilterCleared = "Filter selection cleared";
export var AnnounceFilterResultCount = "Showing {0} filtered items.";
export var AnnounceFinishedLoadingItems = "Finished loading items";
export var AnnounceItemCount = "Showing {0} items.";
export var AnnounceLoadingItems = "Loading items";
export var ClearText = "Clear text";
export var Close = "Close";
export var DropdownCalloutRoleDescription = "Expanded dropdown";
export var DropdownClearActionText = "Clear";
export var DropdownExpandableRoleDescription = "Dropdown";
export var HeaderAriaLabel = "Header {0}";
export var ListboxAriaLabel = "Listbox";
export var Loading = "Loading...";
export var NoFilterResults = "No items matched the supplied filter";
export var NoItemsFound = "No items found";
export var SearchAriaLabel = "Search";
export var Searching = "Searching...";
export var UseItem = "Use \"{0}\"";
